module.exports = __webpack_public_path__ + "img/placeholder.a90773c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appicons/placeholder.jpg
// module id = 140
// module chunks = 1